module.exports = __webpack_public_path__ + "static/media/1001040MF.a7ede1a8.jpg";